export default {
  default: () => import("/app/apps/consumer/layouts/default.vue").then(m => m.default || m),
  "default-with-extended-footer": () => import("/app/apps/consumer/layouts/defaultWithExtendedFooter.vue").then(m => m.default || m),
  "e-gift": () => import("/app/apps/consumer/layouts/eGift.vue").then(m => m.default || m),
  empty: () => import("/app/apps/consumer/layouts/empty.vue").then(m => m.default || m),
  "no-header": () => import("/app/apps/consumer/layouts/noHeader.vue").then(m => m.default || m)
}